import React from 'react';

type AquaristTemplateProps = {
  children: React.ReactNode;
};

const AquaristTemplate: React.FC<AquaristTemplateProps> = ({ children }) => {
  return (
    <section className="detail-page detail-page--aquarist">{children}</section>
  );
};

export default AquaristTemplate;
